import smartParkService from "../axios";

export const PermissionsService = async (park, payloadObj) => {
  const response = await smartParkService.get(
    `api/park/${park.parkid}/rolepermissionrolenames?q=${park.query}`
  );

  const permissionObj = {};

  response.data.forEach((item) => {
    permissionObj[item.feature] = {
      create: Number(item.create),
      read: Number(item.read),
      update: Number(item.update),
      delete: Number(item.delete),
    };
  });

  return permissionObj;
};
